//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, tool, commonData } from "@/mixins/index";
import api from '@/api';
export default {
  name: "repairOrderList",
  mixins: [loadMoreList, tool, commonData],
  data: function data() {
    return {
      pagingReqFn: "repairOrderLog",
      paramsData: {
        status: '',
        pay_order_id: ''
      },
      orderStatus: [{
        label: "成功",
        value: 1
      }, {
        label: "失败",
        value: 2
      }]
    };
  },
  created: function created() {
    this.getNowDate(this.dateType);
  },
  activated: function activated() {
    this.getcommonData(['appListAllData']);
  },
  methods: {}
};